<app-loader *ngIf="isDisabled"></app-loader>
<div class="card" style="min-height: 100%;">
    <div class="card-header">
        <div class="row">
            <div class="col">
                Tax Investment {{GetID == 1?'Approval':'Request'}}
            </div>
            <div class="col-auto">
                <span class="badge"
                    [ngClass]="{'success': common.ToLowerCase(DetailData.ApprovalStatus) == 'approved', 'danger':common.ToLowerCase(DetailData.ApprovalStatus) == 'rejected','warning':common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' || common.ToLowerCase(DetailData.ApprovalStatus) == 'reInitiated' || common.ToLowerCase(DetailData.ApprovalStatus) == 'pendingwithsenior'}">{{DetailData.ApprovalStatus}}</span>
            </div>
        </div>
    </div>
    <div class="card-body p-0">
        <div class="row g-0">
            <div class="col-md-7">
                <div class="card">
                    <div class="card-body p-1">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="row" style="align-items: center;line-height: normal;">
                                    <div class="col-2">
                                        <img *ngIf="DetailData.Photo != null && DetailData.Photo != ''" mat-card-image
                                            class="userImage" [src]="common.PhotoLink(DetailData.Photo)" />
                                        <div *ngIf="DetailData.Photo == null || DetailData.Photo == ''"
                                            class="initial-image">
                                            <div class="image">
                                                {{common.getInitial(DetailData.EmployeeName)}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-9 userdetail">
                                        <label class="form-label"
                                            style="font-size: 13px!important;font-weight: 500; margin-bottom: 0;color: #191d4a;">{{DetailData.EmployeeName}}</label><br />
                                        <label class="form-label"
                                            style="font-size: 10px!important;font-weight: 500; margin-bottom: 0;color: #aaaab2;">#{{DetailData.EmpCode}}</label><br />
                                        <label class="form-label"
                                            style="font-size: 10px!important;font-weight: 500; margin-bottom: 0;color: #aaaab2;">{{DetailData.DesignationName}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col"></div>
                            <div class="col-auto text-end">
                                <label for="RequestDate" class="text-label-light">Request Date</label> <br />
                                <label name="RequestDate" class="text-label-dark">{{DetailData.RequestDate}}</label>
                            </div>
                        </div>
                        <div style="background-color:#0078d42e;border-radius: 5px;" class="p-2 mb-2">
                            <div class="row">
                                <div class="col-md-5">
                                    <label for="FromDate" class="text-label-light">Financial Year Start</label> <br />
                                    <label name="FromDate" class="text-label-dark">{{DetailData.FinancialYearStart |
                                        date :'dd MMM yyyy'}}</label>
                                </div>
                                <div class="col-md-5">
                                    <label for="ToDate" class="text-label-light">Financial Year End</label> <br />
                                    <label name="ToDate" class="text-label-dark">{{DetailData.FinancialYearEnd | date
                                        :'dd MMM yyyy'}}</label>
                                </div>
                                <div class="col-md-2">
                                    <label for="NoOfDays" class="text-label-light">Regime</label> <br />
                                    <label name="NoOfDays"
                                        class="text-label-dark">{{DetailData.IsNewRegime?'New':'Old'}}</label>
                                </div>
                            </div>
                        </div>

                        <div style="background-color:#8080800f;border-radius: 5px;" class="p-2 mb-2">
                            <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{common.ToLowerCase(DetailData.EmpType)
                                        ==
                                        'front'?'Client Location' :common.ToLowerCase(DetailData.EmpType) ==
                                        'back'?'Branch':''}}</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{common.ToLowerCase(DetailData.EmpType)
                                        ==
                                        'front'?DetailData.ClientLocation :common.ToLowerCase(DetailData.EmpType) ==
                                        'back'?DetailData.BranchName:''}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-5 ps-1">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 p-0">
                            <div class="card">
                                <label class="m-2" *ngIf="!isApprovalLavel">{{tooltip.NoApprovalLevel}}</label>
                                <div class="card-body" *ngIf="isApprovalLavel">
                                    <div id="content">
                                        <ul class="timeline">
                                            <li class="event p-0 m-0" *ngFor="let Tracking of TrackingsUser">
                                                <div class="row align-items-center">
                                                    <div class="col-2">
                                                        <img *ngIf="Tracking['Photo'] != null && Tracking['Photo'] != ''"
                                                            mat-card-image class="userImage"
                                                            [src]="common.PhotoLink(Tracking['Photo'])" />
                                                        <div *ngIf="Tracking['Photo'] == null || Tracking['Photo'] == ''"
                                                            class="initial-image">
                                                            <div class="image">
                                                                {{common.getInitial(Tracking['ApproverName'])}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col">
                                                        <h3 class="m-0">
                                                            {{Tracking['ApproverName']}}({{Tracking['ApprovalStage']}})
                                                        </h3>
                                                    </div>
                                                    <div class="col-auto"><span class="badge"
                                                            [ngClass]="{'success': (common.ToLowerCase(Tracking['Status']) == 'approved' || common.ToLowerCase(Tracking['Status']) == 'autoapproved'), 'danger':common.ToLowerCase(Tracking['Status']) == 'rejected','warning':common.ToLowerCase(Tracking['Status']) == 'pending' || common.ToLowerCase(Tracking['Status']) == 'reInitiated'}">{{Tracking['Status']}}</span>
                                                    </div>
                                                </div>
                                                <label class="date">{{Tracking['ActionDate']}}</label>
                                                <p class="remark">{{Tracking['Remark']}}</p>
                                                <input type="text" class="form-control" placeholder="Remark" id="Remark"
                                                    name="Remark" [(ngModel)]="Filter.Remark" #Remark="ngModel"
                                                    [ngClass]="{'is-invalid': this.Filter.isShowError}"
                                                    (change)="removeError()"
                                                    *ngIf="common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(Tracking['Status']) == 'pending' && GetID == 1">

                                                <div class="invalid-feedback"
                                                    *ngIf="common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(Tracking['Status']) == 'pending' && GetID == 1 && this.Filter.isShowError">
                                                    Please Enter Remark!
                                                </div>
                                                <hr />
                                            </li>
                                            <li class="event p-0 m-0" *ngFor="let Tracking of Trackings">
                                                <div class="row align-items-center">
                                                    <div class="col-2">
                                                        <img *ngIf="Tracking['Photo'] != null && Tracking['Photo'] != ''"
                                                            mat-card-image class="userImage"
                                                            [src]="common.PhotoLink(Tracking['Photo'])" />
                                                        <div *ngIf="Tracking['Photo'] == null || Tracking['Photo'] == ''"
                                                            class="initial-image">
                                                            <div class="image">
                                                                {{common.getInitial(Tracking['ApproverName'])}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col">
                                                        <h3>{{Tracking['ApproverName']}}({{Tracking['ApprovalStage']}})
                                                        </h3>
                                                    </div>
                                                    <div class="col-auto"><span class="badge"
                                                            [ngClass]="{'success': (common.ToLowerCase(Tracking['Status']) == 'approved' || common.ToLowerCase(Tracking['Status']) == 'autoapproved'), 'danger':common.ToLowerCase(Tracking['Status']) == 'rejected','warning':common.ToLowerCase(Tracking['Status']) == 'pending' || common.ToLowerCase(Tracking['Status']) == 'reInitiated'}">{{Tracking['Status']}}</span>
                                                    </div>
                                                </div>
                                                <label class="date">{{Tracking['ActionDate']}}</label>
                                                <p class="remark">{{Tracking['Remark']}}</p>
                                            </li>
                                            <li class="event p-0 m-0">
                                                <div class="row">
                                                    <h3>Submitted on</h3>
                                                </div>
                                                <label class="date">{{DetailData.RequestDate}}</label>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row g-0">
            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-briefcase px-2"></i>Previous Employment Details
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardPreviousEmployment?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    id="flexSwitchCheckChecked" [checked]="OpenCard.CardPreviousEmployment"
                                    (change)="onSwitchChange($event,'CardPreviousEmployment')">
                            </div>
                        </div>
                    </div>
                </div>
                <div #collapse="ngbCollapse" [(ngbCollapse)]="!this.OpenCard.CardPreviousEmployment">
                    <div class="card-body">
                        <div class="card-body p-0 px-2">
                            <div class="row">
                                <div class="col p-0">
                                    <div class="table-container">
                                        <table class="customeDatatable table table-bordered">
                                            <thead class="table-light">
                                                <tr>
                                                    <!-- <th class="sticky-col">Month</th>
                                                    <th class="sticky-col">Year</th> -->
                                                    <th>Remark</th>
                                                    <th>Basic</th>
                                                    <th class="text-end">DA</th>
                                                    <th class="text-end">HRA</th>
                                                    <th class="text-end">Allowance</th>
                                                    <th class="text-end">Gross</th>
                                                    <th class="text-end">PT</th>
                                                    <th class="text-end">PF</th>
                                                    <th class="text-end">TDS</th>
                                                    <th class="text-end">Deduction</th>
                                                    <th class="text-end">Net</th>
                                                    <th class="sticky-col">Attachment</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let element of TablesData.ESS_TaxPreviousEmploymentDetails; let i = index">
                                                    <!-- <td class="sticky-col">
                                                        {{element.Monthname}}
                                                    </td>
                                                    <td class="sticky-col align-center">
                                                        {{element.Yearname}}
                                                    </td> -->
                                                    <td>
                                                        {{element.Remarks}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.Basic}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.DA}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.HRA}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.OtherAllowance}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.GrossAmount}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.PT}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.PF}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.TDS}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.OtherDeduction}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.NetAmount}}
                                                    </td>
                                                    <td class="sticky-col"
                                                        style="align-content: center;text-align: -webkit-center;">
                                                        <i type="button"
                                                            class="bi bi-file-earmark-arrow-down cursor-pointer position-relative fs-5"
                                                            (click)="attachmentPopup(i,1)">
                                                            <span
                                                                class="position-absolute top-0 start-1 translate-middle badge rounded-pill bg-primary"
                                                                style="font-size: 10px;">
                                                                {{element.ESS_EmpTaxInvestmentPrevEmployment_Attachment.length}}
                                                            </span>
                                                        </i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row g-0">
            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-card-checklist px-2"></i>Chapter VI A Details
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardEmpTaxDeclarationDetails?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    id="flexSwitchCheckChecked" [checked]="OpenCard.CardEmpTaxDeclarationDetails"
                                    (change)="onSwitchChange($event,'CardEmpTaxDeclarationDetails')">
                            </div>
                        </div>
                    </div>
                </div>
                <div #collapse="ngbCollapse" [(ngbCollapse)]="!this.OpenCard.CardEmpTaxDeclarationDetails">
                    <div class="card-body">
                        <div class="card-body p-0 px-2">
                            <div class="row">
                                <div class="col p-0">
                                    <div class="table-container">
                                        <table class="customeDatatable table table-bordered">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>Section Code</th>
                                                    <th>Section</th>
                                                    <th>IncomeHead</th>
                                                    <th>Sub Section</th>
                                                    <th>Limit Applicable</th>
                                                    <th>Max Limit</th>
                                                    <th class="text-end">Proof Submission Amount</th>
                                                    <th class="text-end">Approved Amount</th>
                                                    <th class="sticky-col">Attachment</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let element of TablesData.ESS_EmpTaxInvestmentDetails; let i = index">
                                                    <td>{{element.SectionCode}}</td>
                                                    <td>{{element.SectionName}}</td>
                                                    <td>{{element.IncomeHead}}</td>
                                                    <td>{{element.SubSectionName}}</td>
                                                    <td>{{element.LimitApplicable?'Yes':'No'}}</td>
                                                    <td class="text-end">{{element.MaxLimitAmount}}</td>
                                                    <td class="text-end">{{element.ProofSubmissionAmount}}</td>
                                                    <td class="text-end">
                                                        <input *ngIf="(common.ToLowerCase(DetailData.ApprovalStatus) == 'pending'
                                                        && common.ToLowerCase(TrackingsUser.length >
                                                        0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) ||
                                                        (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' &&
                                                        isSuper && GetID == 1)" type="text"
                                                            class="form-control custom-control" placeholder="Ex. 10000"
                                                            name="ESS_EmpTaxInvestmentDetailsApprovedAmount{{i}}"
                                                            [(ngModel)]="element.ApprovedAmount"
                                                            #ESS_EmpTaxInvestmentDetailsApprovedAmount="ngModel"
                                                            pattern="^[0-9]\d*$"
                                                            (keypress)="common.NumberOnly($event,true)" maxlength="6"
                                                            required>

                                                        <div *ngIf="!((common.ToLowerCase(DetailData.ApprovalStatus) == 'pending'
                                                        && common.ToLowerCase(TrackingsUser.length >
                                                        0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) ||
                                                        (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' &&
                                                        isSuper && GetID == 1))">{{element.ApprovedAmount}}</div>
                                                    </td>
                                                    <td class="sticky-col"
                                                        style="align-content: center;text-align: -webkit-center;">
                                                        <i type="button"
                                                            class="bi bi-file-earmark-arrow-down cursor-pointer position-relative fs-5"
                                                            (click)="attachmentPopup(i,1)">
                                                            <span
                                                                class="position-absolute top-0 start-1 translate-middle badge rounded-pill bg-primary"
                                                                style="font-size: 10px;">
                                                                {{element.ESS_EmpTaxInvestmentDetails_Attachment.length}}
                                                            </span>
                                                        </i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row g-0">
            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-house px-2"></i>Are you staying in a rented house?
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardEmpTaxDeclarationDetails_HRA?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    id="flexSwitchCheckChecked" [checked]="OpenCard.CardEmpTaxDeclarationDetails_HRA"
                                    (change)="onSwitchChange($event,'CardEmpTaxDeclarationDetails_HRA')">
                            </div>
                        </div>
                    </div>
                </div>
                <div #collapse="ngbCollapse" [(ngbCollapse)]="!this.OpenCard.CardEmpTaxDeclarationDetails_HRA">
                    <div class="card-body">
                        <div class="card-body p-0 px-2">
                            <div class="row">
                                <div class="col p-0">
                                    <div class="table-container">
                                        <table class="customeDatatable table table-bordered">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>FromDate</th>
                                                    <th>ToDate</th>
                                                    <th class="text-end">Monthly Rent</th>
                                                    <th>Name Of Landloard</th>
                                                    <th>Land LordPanNo</th>
                                                    <th>Address</th>
                                                    <th>IsMetroCity</th>
                                                    <th class="text-end">Submission Amount</th>
                                                    <th class="text-end">Approved Amount</th>
                                                    <th>Attachment</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let element of TablesData.ESS_EmpTaxDeclarationDetails_HRA; let i = index">
                                                    <td>
                                                        {{element.FromDate}}
                                                    </td>
                                                    <td>
                                                        {{element.ToDate}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.ApprovedAmount}}
                                                    </td>
                                                    <td>
                                                        {{element.NameOfLandlord}}
                                                    </td>
                                                    <td>
                                                        {{element.LandLordPanNo}}
                                                    </td>
                                                    <td>
                                                        {{element.Address}}
                                                    </td>
                                                    <td style="align-content: center;text-align: -webkit-center;">
                                                        {{element.IsMetroCity?'Yes':'No'}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.ProofSubmissionAmount}}
                                                    </td>
                                                    <td class="text-end">
                                                        <input *ngIf="(common.ToLowerCase(DetailData.ApprovalStatus) == 'pending'
                                                        && common.ToLowerCase(TrackingsUser.length >
                                                        0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) ||
                                                        (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' &&
                                                        isSuper && GetID == 1)" type="text"
                                                            class="form-control custom-control" placeholder="Ex. 10000"
                                                            name="ESS_EmpTaxDeclarationDetails_HRAApprovedAmount{{i}}"
                                                            [(ngModel)]="element.ApprovedAmount"
                                                            #ESS_EmpTaxDeclarationDetails_HRAApprovedAmount="ngModel"
                                                            pattern="^[0-9]\d*$"
                                                            (keypress)="common.NumberOnly($event,true)" maxlength="6"
                                                            required>

                                                        <div *ngIf="!((common.ToLowerCase(DetailData.ApprovalStatus) == 'pending'
                                                        && common.ToLowerCase(TrackingsUser.length >
                                                        0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) ||
                                                        (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' &&
                                                        isSuper && GetID == 1))">{{element.ApprovedAmount}}</div>
                                                    </td>

                                                    <td style="align-content: center;text-align: -webkit-center;">
                                                        <i type="button"
                                                            class="bi bi-file-earmark-arrow-down cursor-pointer position-relative fs-5"
                                                            (click)="attachmentPopup(i,3)">
                                                            <span
                                                                class="position-absolute top-0 start-1 translate-middle badge rounded-pill bg-primary"
                                                                style="font-size: 10px;">
                                                                {{element.ESS_EmpTaxInvestmentDetails_HRAAttachment.length}}
                                                            </span>
                                                        </i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="row g-0">
            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-house px-2"></i>Are you staying in a rented house?
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardEmpTaxDeclarationDetails_HRA?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    id="flexSwitchCheckChecked" [checked]="OpenCard.CardEmpTaxDeclarationDetails_HRA"
                                    (change)="onSwitchChange($event,'CardEmpTaxDeclarationDetails_HRA')">
                            </div>
                        </div>
                    </div>
                </div>
                <div #collapse="ngbCollapse" [(ngbCollapse)]="!this.OpenCard.CardEmpTaxDeclarationDetails_HRA">
                    <div class="card-body">
                        <div class="card-body p-0 px-2">
                            <div class="row">
                                <div class="col p-0">
                                    <div class="table-container">
                                        <table class="customeDatatable table table-bordered">
                                            <thead class="table-light">
                                                <tr>
                                                    <th class="text-end">Annual Rent Received</th>
                                                    <th class="text-end">Municipal Taxes</th>
                                                    <th class="text-end">Net AnnualValue</th>
                                                    <th class="text-end">Standard Deduction 30%</th>
                                                    <th>Repaying HomeLoan</th>
                                                    <th class="text-end">Principal Paid OnHomeLoan</th>
                                                    <th class="text-end">Interest Paid OnHomeLoan</th>
                                                    <th>Name Of TheLender</th>
                                                    <th>Lender PanNo</th>
                                                    <th class="text-end">NetIncome/Loss</th>
                                                    <th>Attachment</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let element of TablesData.ESS_EmpTaxDeclarationDetails_LOP; let i = index">
                                                    <td class="text-end">
                                                        {{element.AnnualRentReceived}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.MunicipalTaxesPaid}}
                                                    </td>
                                                    <td class="text-end">
                                                        <span class="custom-control">{{element.NetAnnualValue}}</span>
                                                    </td>
                                                    <td class="text-end">
                                                        <span
                                                            class="custom-control">{{element.StandardDeduction}}</span>
                                                    </td>
                                                    <td style="align-content: center;text-align: -webkit-center;">
                                                        {{element.RepayingHomeLoanForThisProperty?'Yes':"No"}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.PrincipalPaidOnHomeLoan}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.InterestPaidOnHomeLoan}}
                                                    </td>
                                                    <td>
                                                        {{element.NameOfTheLender}}
                                                    </td>
                                                    <td>
                                                        {{element.LenderPanNo}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.NetIncomeLossFromHouseProperty}}
                                                    </td>
                                                    <td style="align-content: center;text-align: -webkit-center;">
                                                        <i type="button"
                                                            class="bi bi-file-earmark-arrow-down cursor-pointer position-relative fs-5"
                                                            (click)="attachmentPopup(i, 4)">
                                                            <span
                                                                class="position-absolute top-0 start-1 translate-middle badge rounded-pill bg-primary"
                                                                style="font-size: 10px;">
                                                                {{element.ESS_EmpTaxInvestmentDetails_LOPAttachment.length}}
                                                            </span>
                                                        </i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row g-0">
            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-cash-stack px-2"></i>Are you receiving rental income from Let out
                                Property?
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardEmpTaxDeclarationDetails_LOP?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    id="flexSwitchCheckChecked" [checked]="OpenCard.CardEmpTaxDeclarationDetails_LOP"
                                    (change)="onSwitchChange($event,'CardEmpTaxDeclarationDetails_LOP')">
                            </div>
                        </div>
                    </div>
                </div>
                <div #collapse="ngbCollapse" [(ngbCollapse)]="!this.OpenCard.CardEmpTaxDeclarationDetails_LOP">
                    <div class="card-body">
                        <div class="card-body p-0 px-2">
                            <div class="row">
                                <div class="col p-0">
                                    <div class="table-container">
                                        <table class="customeDatatable table table-bordered">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>SubSection Name</th>
                                                    <th>SubSection Description</th>
                                                    <th>Limit Applicable</th>
                                                    <th class="text-end">MaxLimit Amount</th>
                                                    <th class="text-end">Declared Amount</th>
                                                    <th class="text-end">Approved Amount</th>
                                                    <th>Attachment</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let element of TablesData.ESS_EmpTaxDeclarationDetails_Others; let i = index">
                                                    <td>{{element.SubSectionName}}</td>
                                                    <td>{{element.SubSectionDescription}}</td>
                                                    <td>{{element.LimitApplicable?'Yes':'No'}}</td>
                                                    <td class="text-end">{{element.MaxLimitAmount}}</td>
                                                    <td class="text-end">{{element.ProofSubmissionAmount}}</td>
                                                    <td class="text-end">
                                                        <input *ngIf="(common.ToLowerCase(DetailData.ApprovalStatus) == 'pending'
                                                        && common.ToLowerCase(TrackingsUser.length >
                                                        0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) ||
                                                        (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' &&
                                                        isSuper && GetID == 1)" type="text"
                                                            class="form-control custom-control" placeholder="Ex. 10000"
                                                            name="ESS_EmpTaxDeclarationDetails_OthersApprovedAmount{{i}}"
                                                            [(ngModel)]="element.ApprovedAmount"
                                                            #ESS_EmpTaxDeclarationDetails_OthersApprovedAmount="ngModel"
                                                            pattern="^[0-9]\d*$"
                                                            (keypress)="common.NumberOnly($event,true)" maxlength="6"
                                                            required>

                                                        <div *ngIf="!((common.ToLowerCase(DetailData.ApprovalStatus) == 'pending'
                                                        && common.ToLowerCase(TrackingsUser.length >
                                                        0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) ||
                                                        (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' &&
                                                        isSuper && GetID == 1))">{{element.ApprovedAmount}}</div>
                                                    </td>
                                                    <td style="align-content: center;text-align: -webkit-center;">
                                                        <i type="button"
                                                            class="bi bi-file-earmark-arrow-down cursor-pointer position-relative fs-5"
                                                            (click)="attachmentPopup(i, 4)">
                                                            <span
                                                                class="position-absolute top-0 start-1 translate-middle badge rounded-pill bg-primary"
                                                                style="font-size: 10px;">
                                                                {{element.ESS_EmpTaxInvestmentDetails_OthersAttachment.length}}
                                                            </span>
                                                        </i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end notification-action">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="Cancel()"><i
                    class="bi bi-arrow-left" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Cancel':'Loading...'}}</button>
            <button type="button" class="btn btn-success mx-1" [disabled]="isDisabled"
                [routerLink]="['/incometax/compare/ai/' + this.DetailData.TransactionId]"><i
                    class="bi bi-bookmark-check" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Compare':'Loading...'}}</button>
            <button *ngIf="(common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(TrackingsUser.length > 0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) || 
                (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && isSuper && GetID == 1)" type="button"
                class="btn btn-danger" [disabled]="isDisabled" (click)="ApprovalMatrixRequestProcess('Reject')"><i
                    class="bi bi-x" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Reject':'Loading...'}}</button>

            <button *ngIf="(common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(TrackingsUser.length > 0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) || 
                (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && isSuper && GetID == 1)" type="button"
                class="btn btn-success" [disabled]="isDisabled" (click)="ApprovalMatrixRequestProcess('Approve')"><i
                    class="bi bi-check2" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Approve':'Loading...'}}</button>
        </div>
    </div>
</div>